export const tableCellStyles = {
  fontSize: "10px",
  borderBottom: "none",
  "&.MuiTableCell-root.MuiTableCell-root": {
    paddingTop: "12px",
    fontFamily: "Inter",
  },
};

export const tableCellCenterStyles = {
  ...tableCellStyles,
  textAlign: "center",
};

export const tableCellAmtEndStyles = {
  fontSize: "10px",
  borderBottom: "none",
  textAlign: "end",
  "&.MuiTableCell-root.MuiTableCell-root": {
    paddingTop: "12px",
    paddingRight: "10px",
    fontFamily: "Inter",
  },
};

export const tableCellEndStyles = {
  ...tableCellStyles,
  textAlign: "end",
  "&.MuiTableCell-root.MuiTableCell-root": {
    paddingRight: "10px",
    fontFamily: "Inter",
  },
};

export const dutyLabelStyles = {
  width: "50%",
  borderRight: "3px solid black",
  textAlign: "end",
  borderBottom: "none",
  fontSize: "10px",
  "&.MuiTableCell-root.MuiTableCell-root": {
    paddingRight: "5px",
    fontFamily: "Inter",
  },
};
